module.exports = __webpack_public_path__ + "static/media/top__copy.2650c8b7.png";